import { useStorage } from '@lamimed/utils';
import { useRouter } from 'next/router';

import { authTokenStorageKey } from 'hooks/useAuthentication';

export const useLogout = () => {
  const { remove } = useStorage();
  const router = useRouter();

  const logout = () => {
    remove(authTokenStorageKey);

    router.push('/');
  };

  return { logout };
};
